/* eslint-disable eqeqeq */
import React, { useState, useRef, useEffect } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Swal from "sweetalert2";
import BuscaForm from "../../gww-lib/busca-no-form/index";
import validaString from "../../../tools/validaString";
import validaNumber from "../../../tools/validaNumber";
import somenteDecimal from "../../../tools/somenteDecimal";
import apresentarDecimal from "../../../tools/apresentarDecimal";
import mascaraPreco from "../../../tools/mascaras/real";
import dbToBoolean from "../../../tools/dbToBoolean";
import Grid from "@material-ui/core/Grid";
import CampoTextoAjuda from "../../gww-lib/campo-texto-ajuda";
import consultaApi from "../../../services/consultaApi";

const useStyles = makeStyles((theme) => ({
  controlaTitulo: {
    paddingTop: 30,
    paddingBottom: 12,
    fontSize: "2em",
  },
  corDoFundo: {
    backgroundColor: "#f1f1f1",
    paddingBottom: 30,
  },
  controlaCard: {
    textAlign: "center",
    padding: theme.spacing(2),
  },
  formControl: {
    marginBottom: 8,
  },
  ocultaCampo: {
    display: "none",
  },
  botaoRodape: {
    padding: theme.spacing(1),
  },
}));

function FormProduto(props) {
  const { produto } = props;

  const classes = useStyles();

  const [codigoProduto] = useState(produto.CCDPMS ? produto.CCDPMS : 0);

  const [descricao, setDescricao] = useState(
    produto.CDSPMS ? produto.CDSPMS : ""
  );
  const [descricaoErro, setDescricaoErro] = useState(false);
  const [descricaoErroTexto, setDescricaoErroTexto] = useState();

  const [descricaoDetalhada, setDescricaoDetalhada] = useState(
    produto.CMSGNFPROD ? produto.CMSGNFPROD : ""
  );

  const [origem, setOrigem] = useState(
    produto.CCDSITORIG ? produto.CCDSITORIG : 0
  );
  const [origemErro] = useState(false);
  const [origemErroTexto] = useState();

  const [unidade, setUnidade] = useState(
    produto.CCDUNID ? produto.CCDUNID : localStorage.getItem("UNIDADE_PADRAO")
  );
  const [descricaoUnidade, setDescricaoUnidade] = useState(
    produto.CDSUNID
      ? produto.CDSUNID
      : localStorage.getItem("DESCRICAO_UNIDADE_PADRAO")
  );
  const [unidadeErro, setUnidadeErro] = useState(false);
  const [unidadeErroTexto, setUnidadeErroTexto] = useState();

  const [codigoBarras, setCodigoBarras] = useState(
    produto.CCDEAN ? produto.CCDEAN : ""
  );
  const [codigoBarrasErro, setCodigoBarrasErro] = useState(false);
  const [codigoBarrasErroTexto, setCodigoBarrasErroTexto] = useState();

  const [codigoNcm, setCodigoNcm] = useState(
    produto.CCDNCM ? produto.CCDNCM : ""
  );
  const [descricaoNcm, setDescricaoNcm] = useState(
    produto.CDSNCM ? produto.CDSNCM : ""
  );
  const [ncmErro, setNcmErro] = useState(false);
  const [ncmErroTexto, setNcmErroTexto] = useState();

  const [cfop, setCfop] = useState(
    produto.PCCDCFOP ? produto.PCCDCFOP : localStorage.getItem("CFOP_PADRAO")
  );
  const [descricaoCfop, setDescricaoCfop] = useState(
    produto.CDSCFOP
      ? produto.CDSCFOP
      : localStorage.getItem("DESCRICAO_CFOP_PADRAO")
  );
  const [cfopErro, setCfopErro] = useState(false);
  const [cfopErroTexto, setCfopErroTexto] = useState();

  const [grupoImposto, setGrupoImposto] = useState(
    produto.CCDTAXGRUPO
      ? produto.CCDTAXGRUPO
      : localStorage.getItem("GRUPO_IMPOSTO_PADRAO")
  );
  const [descricaoGrupoImposto, setDescricaoGrupoImposto] = useState(
    produto.CDSTAXGRUPO
      ? produto.CDSTAXGRUPO
      : localStorage.getItem("DESCRICAO_GRUPO_IMPOSTO_PADRAO")
  );
  const [grupoImpostoErro, setGrupoImpostoErro] = useState(false);
  const [grupoImpostoErroTexto, setGrupoImpostoErroTexto] = useState();

  const [preco, setPreco] = useState(
    produto.NVLPROD ? apresentarDecimal(produto.NVLPROD) : ""
  );
  const [precoErro] = useState(false);
  const [precoErroTexto] = useState();

  const [ativo, setAtivo] = useState(
    produto.CCDPMS > 0 ? dbToBoolean(produto.LPDATIVO) : true
  );

  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);

  const history = useHistory();

  function vaiListagem() {
    history.push("/produto");
  }

  async function salvar(e) {
    e.preventDefault();
    if (validaCampos()) {
      Swal.fire({
        type: "question",
        title: "Salvar Produto ?",
        showCancelButton: true,
        confirmButtonText: "Salvar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: (result) => {
          return new Promise(async (resolve, reject) => {
            let dadosProduto = {
              PROCNAME: "WEBSITE_GPMS_ADD",
              PCCDPMS: codigoProduto,
              PCDSPMS: descricao.toUpperCase(),
              PCMSGNFPROD: descricaoDetalhada.toUpperCase(),
              PCCDSITORIG: origem,
              PCCDUNID: unidade.toUpperCase(),
              PCCDEAN: codigoBarras,
              PCCDNCM: codigoNcm,
              PPCCDCFOP: cfop,
              PCCDTAXGRUPO: grupoImposto,
              PNVLPROD: somenteDecimal(preco),
              PLPDATIVO: ativo ? 1 : 0,
            };

            const resposta = await consultaApi(dadosProduto);

            resolve(resposta.data);
          });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.value) {
          if (result.value.CODIGO_ERRO == 0) {
            Swal.fire({
              type: "success",
              html: result.value.MENSAGEM_RESPOSTA,
            });
            vaiListagem();
          } else {
            Swal.fire({
              type: "error",
              html: result.value.MENSAGEM_RESPOSTA,
            });
          }
        }
      });
    }
  }

  function cancelar() {
    Swal.fire({
      type: "question",
      title: "Cancelar ?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      showLoaderOnConfirm: true,
      preConfirm: (result) => {
        if (result) {
          vaiListagem();
        }
      },
    });
    //
  }

  function validaCampos() {
    let camposErrados = [];

    if (descricao === "") {
      setDescricaoErro(true);
      setDescricaoErroTexto(`Campo Obrigatorio, Por favor preencha`);
      camposErrados.push("Descrição");
    } else {
      setDescricaoErro(false);
    }

    if (unidade === "") {
      setUnidadeErro(true);
      setUnidadeErroTexto(`Campo obrigatorio, Por favor preencha`);
      camposErrados.push("Unidade");
    } else {
      if (descricaoUnidade === "") {
        setUnidadeErro(true);
        setUnidadeErroTexto("Informe uma unidade valida, use a pesquisa.");
        camposErrados.push("Unidade");
      } else {
        setUnidadeErro(false);
      }
    }

    if (codigoNcm === "") {
      setNcmErro(true);
      setNcmErroTexto(`Campo obrigatorio, Por favor preencha`);
      camposErrados.push("NCM");
    } else {
      if (descricaoNcm === "") {
        setNcmErro(true);
        setNcmErroTexto("Informe um NCM valido, use a pesquisa.");
        camposErrados.push("NCM");
      } else {
        setNcmErro(false);
      }
    }

    if (cfop === "") {
      setCfopErro(true);
      setCfopErroTexto(`Campo obrigatorio, Por favor preencha`);
      camposErrados.push("CFOP");
    } else {
      if (descricaoCfop === "") {
        setCfopErro(true);
        setCfopErroTexto(`Informe um CFOP valido, use a pesquisa.`);
        camposErrados.push("CFOP");
      } else {
        setCfopErro(false);
      }
    }

    if (grupoImposto === "") {
      setGrupoImpostoErro(true);
      setGrupoImpostoErroTexto(`Campo obrigatorio, Por favor preencha`);
      camposErrados.push("Grupo de Imposto");
    } else {
      if (descricaoGrupoImposto === "") {
        setGrupoImpostoErro(true);
        setGrupoImpostoErroTexto(
          `Informe um Grupo de Imposto valido, use a pesquisa.`
        );
        camposErrados.push("Grupo de Imposto");
      } else {
        setGrupoImpostoErro(false);
      }
    }

    if (
      codigoBarras.length != 0 &&
      codigoBarras.length != 8 &&
      codigoBarras.length != 12 &&
      codigoBarras.length != 13 &&
      codigoBarras.length != 14
    ) {
      setCodigoBarrasErro(true);
      setCodigoBarrasErroTexto(`Codigo de barras invalido`);
      camposErrados.push("Código de Barras");
    } else {
      setCodigoBarrasErro(false);
    }

    if (camposErrados.length === 0) {
      return true;
    } else {
      Swal.fire({
        type: "error",
        title: "Campos Inválidos",
        html:
          `<lu>` +
          camposErrados.map((campoErrado) => `<li>${campoErrado}</li>`) +
          `</lu>`,
      });

      return false;
    }
  }

  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <Container className={classes.corDoFundo}>
      <Typography
        variant="h1"
        component="h1"
        gutterBottom
        align="center"
        color="primary"
        className={classes.controlaTitulo}
      >
        Cadastro de Produto
      </Typography>

      <Paper className={classes.controlaCard}>
        <form>
          <Grid container>
            <Grid item xs={12}>
              <CampoTextoAjuda
                className={classes.textField}
                label="Descrição *"
                error={descricaoErro}
                helperText={descricaoErroTexto}
                value={descricao}
                onChange={(e) => validaString(setDescricao, 60, e.target.value)}
                tituloAjuda="Descrição do Produto"
                textoAjuda="Informar uma breve descrição do produto. Exemplo: Copo para café."
                saibaMais={{
                  categoria: "produto",
                  campo: "descricao",
                }}
              />
            </Grid>

            {localStorage.getItem("APRESENTA_DESCRICAO_DETALHADA") != "0" && (
              <Grid item xs={12}>
                <CampoTextoAjuda
                  className={classes.textField}
                  label="Descrição detalhada"
                  required
                  multiline
                  rows={4}
                  value={descricaoDetalhada}
                  onChange={(e) =>
                    validaString(setDescricaoDetalhada, 400, e.target.value)
                  }
                  tituloAjuda="Descrição detalhada do Produto"
                  textoAjuda="Informar uma breve descrição detalhada do produto. Exemplo: Tipo, especificações."
                  saibaMais={{
                    categoria: "produto",
                    campo: "descricao detalhada",
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
              >
                <InputLabel ref={inputLabel}>Origem</InputLabel>
                <Select
                  error={origemErro}
                  helperText={origemErroTexto}
                  value={origem}
                  onChange={(e) => setOrigem(e.target.value)}
                  labelWidth={labelWidth}
                >
                  <MenuItem value={0}>0 - Nacional</MenuItem>
                  <MenuItem value={1}>
                    1 - Estrangeira, importação direta
                  </MenuItem>
                  <MenuItem value={2}>
                    2 - Estrangeira, adquirida no mercado interno
                  </MenuItem>
                  <MenuItem value={3}>
                    3 - Nacional, importação superior a 40%
                  </MenuItem>
                  <MenuItem value={4}>
                    4 - Nacional, cuja produção tenha sido feita em conformidade
                    com os processos produtivos básicos de que tratam as
                    legislações citadas nos ajustes
                  </MenuItem>
                  <MenuItem value={5}>
                    5 - Nacional, mercadoria ou bem com conteúdo de importação
                    inferior ou igual a 40%
                  </MenuItem>
                  <MenuItem value={6}>
                    6 - Estrangeira - importação direta, sem similar nacional,
                    constante em lista da camex
                  </MenuItem>
                  <MenuItem value={7}>
                    7 - Estrangeira - adquirida no mercado interno, sem similar
                    nacional, constante em lista da camex
                  </MenuItem>
                  <MenuItem value={8}>
                    8 - Nacional, mercadoria ou bem com conteúdo de importação
                    superioro a 70%
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <BuscaForm
                codigo={unidade}
                tabela="UNIDADE"
                label="Unidade de Medida"
                consultaInstantanea
                setCodigoPai={(unidade) => setUnidade(unidade)}
                setDescricao={setDescricaoUnidade}
                descricao={descricaoUnidade}
                procedureConsulta="WEBSITE_LISTAGEM_UNID"
                erroTexto={unidadeErroTexto}
                erro={unidadeErro}
                tipo="text"
                ajuda={{
                  obrigatorio: true,
                  tituloAjuda: "Unidade do Produto",
                  textoAjuda:
                    "Escolher a unidade de medida que o produto será comercializado. Exemplo: Unidade, caixa, bisnaga, entre outros.",
                  saibaMais: {
                    categoria: "produto",
                    campo: "unidade",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <CampoTextoAjuda
                className={classes.textField}
                label="Código de Barras"
                error={codigoBarrasErro}
                helperText={codigoBarrasErroTexto}
                value={codigoBarras}
                onChange={(e) =>
                  validaNumber(setCodigoBarras, 14, e.target.value)
                }
                tituloAjuda="Código de Barras"
                textoAjuda="Informar o codio de barras que consta no produto"
                saibaMais={{
                  categoria: "produto",
                  campo: "codigo-barras",
                }}
                obrigatorio={false}
              />
            </Grid>

            <Grid item xs={12}>
              <BuscaForm
                codigo={codigoNcm}
                tabela="NCM"
                label="NCM"
                erroTexto={ncmErroTexto}
                erro={ncmErro}
                setCodigoPai={(codigoNcm) => setCodigoNcm(codigoNcm)}
                descricao={descricaoNcm}
                setDescricao={setDescricaoNcm}
                procedureConsulta="WEBSITE_LISTAGEM_GNCM"
                ajuda={{
                  obrigatorio: true,
                  tituloAjuda: "NCM",
                  textoAjuda:
                    "(Nomenclatura Comum do Mercosul) esta informação pode ser encontrada na nota fiscal de compra ou você poderá verificar está informação com seu contador. Se preferir é só pesquisar na caixa de busca",
                  saibaMais: {
                    categoria: "produto",
                    campo: "ncm",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <BuscaForm
                codigo={cfop}
                tabela="CFOP"
                label="CFOP"
                erroTexto={cfopErroTexto}
                erro={cfopErro}
                setCodigoPai={(cfop) => setCfop(cfop)}
                descricao={descricaoCfop}
                setDescricao={setDescricaoCfop}
                procedureConsulta="WEBSITE_LISTAGEM_TCFOP"
                ajuda={{
                  obrigatorio: true,
                  tituloAjuda: "CFOP",
                  textoAjuda:
                    "Código Fiscal de Operações e Prestações , em caso de dúvida você poderá verificar está informação com seu contador.",
                  saibaMais: {
                    categoria: "produto",
                    campo: "cfop",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <BuscaForm
                codigo={grupoImposto}
                tabela="GRUPO_IMPOSTO"
                filtro="CDSTAXGRUPO"
                label="Grupo de Imposto"
                consultaInstantanea
                erroTexto={grupoImpostoErroTexto}
                erro={grupoImpostoErro}
                setCodigoPai={(grupoImposto) => setGrupoImposto(grupoImposto)}
                descricao={descricaoGrupoImposto}
                setDescricao={setDescricaoGrupoImposto}
                procedureConsulta="WEBSITE_LISTAGEM_IMP_GRUPO"
                ajuda={{
                  obrigatorio: true,
                  tituloAjuda: "Grupo de Imposto",
                  textoAjuda:
                    "Informar um grupo de imposto que foi previamente cadastrado, o grupo informado nesse cadastro será sugerido no momento em que informar o produto na nota fiscal eletrônica.",
                  saibaMais: {
                    categoria: "produto",
                    campo: "grupo-imposto",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <CampoTextoAjuda
                classe={classes.textField}
                label="Preço"
                error={precoErro}
                helperText={precoErroTexto}
                value={preco}
                onChange={(e) => setPreco(e.target.value)}
                tituloAjuda="Preço do Produto"
                textoAjuda="Informar o preço do produto que será sugerido no momento que for ser utilizado em uma nota fiscal."
                obrigatorio={false}
                saibaMais={{
                  categoria: "produto",
                  campo: "preco",
                }}
                InputProps={{
                  inputComponent: mascaraPreco,
                }}
              />
            </Grid>
            {codigoProduto > 0 && (
              <Grid item xs={12} align="center">
                <FormControlLabel
                  className={classes.formControl}
                  control={
                    <Switch
                      checked={ativo}
                      onChange={(e) => setAtivo(e.target.checked)}
                      name="checkedA"
                      color="primary"
                      inputProps={{ "aria-label": "Ativo" }}
                    />
                  }
                  label="Ativo"
                />
              </Grid>
            )}

            <Grid item xs={6} className={classes.botaoRodape}>
              <Button
                variant="contained"
                color="secondary"
                type="button"
                onClick={cancelar}
                fullWidth
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={6} className={classes.botaoRodape}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={salvar}
                fullWidth
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
}

export default withRouter(FormProduto);
